// src/components/auth.js

import axios from "axios";

/* =========================================================
   GET CURRENT USER
========================================================= */
export async function getCurrentUser() {

  try {

    const res = await axios.get(
      "/api/auth/me",
      {
        withCredentials: true,
      }
    );

    return res.data;

  } catch (error) {

    const status =
      error?.response?.status;

    if (
      status !== 401 &&
      status !== 403
    ) {

    }

    throw error;

  }

}